<template>
    <div>
        <TitleImage image="contact" title="Contacto" />    
        <div class="spacer"></div>
        <div class="col-md-8 col-lg-6 col-sm-12 container">
            <div v-if="!submit">
                <h1 class="h2">Estamos atentos a tus dudas y comentarios</h1>
                <form role="form" @submit.prevent="doSubmit" class="lead mt-4">

                    <div class="form-group">
                        <label for="name">Nombre y apellido</label>
                        <input type="text" class="form-control" id="name" placeholder="Ingresá tu nombre y apellido" v-model="form.name" required> 
                    </div>         
                    
                    <div class="form-group mt-4"> 
                        <label for="contact">Correo o teléfono</label>             
                        <input type="text" class="form-control" id="contact" placeholder="Ingresá tu correo o teléfono" v-model="form.contact" required> 
                    </div>

                    <div class="form-group mt-4"> 
                        <label for="category">Categoría</label>             
                        <select class="custom-select" required v-model="form.category">
                            <option v-for="(category, index) in categories" :key="index" :value="category">{{category}}</option>
                        </select>
                    </div>

                    <div class="form-group mt-4">
                        <label for="message">Mensaje</label>
                        <textarea class="form-control" id="message" rows="6" placeholder="Escrbí tu mensaje" v-model="form.message" required></textarea>
                    </div>         
                    <button type="submit" class="btn btn-primary">Enviar</button>
                </form>
            </div>
            <div v-else>
                <h1 class="h2">Gracias. Tu mensaje fue enviado.</h1>
                <RouterLink :to="{name: 'Home'}" class="btn btn-primary mt-4">Seguir navegando</RouterLink>
            </div>
            <div class="spacer"></div>
        </div>
        <Contact />
    </div>
</template>

<script>
import TitleImage from '@/components/TitleImage'
import Contact from '@/components/Contact'

export default {
    name: 'ContactView',
    components:{
        TitleImage,
        Contact
    },
    data(){
        return {
            form:{
                name: '',
                contact: '',
                category: require('@/assets/json/contact.json').categories[0],
                message: ''
            },
            categories: require('@/assets/json/contact.json').categories,
            submit: false
        }
    },
    methods:{
        doSubmit(){
            this.$store.dispatch('message/doCreate', this.form)
            window.scrollTo(0,0)
            this.submit = true            
        }
    }
}
</script>